import * as api from "services/api";
import { getErrors } from "helpers/error";
import { Callback } from "Types/Callback";
import IMei from "Types/IMei";
import { State } from "store/reducers";
import { CNPJValidation } from "helpers/validators";

export const GET_MEI = "[MEI EDIT] GET_MEI";
export const GET_MEI_SUCCESS = "[MEI EDIT] GET_MEI_SUCCESS";
export const GET_MEI_FAILED = "[MEI EDIT] GET_MEI_FAILED";

export const EDIT_MEI = "[MEI EDIT] EDIT_MEI";
export const EDIT_MEI_SUCCESS = "[MEI EDIT] EDIT_MEI_SUCCESS";
export const EDIT_MEI_FAILED = "[MEI EDIT] EDIT_MEI_FAILED";

export const SET_VALUE = "[MEI EDIT] SET_VALUE";
export const CLEAR_VALUES = "[MEI EDIT] CLEAR_VALUES";

export function setValue(payload: any) {
	return (dispatch: any) => {
		dispatch({ type: SET_VALUE, payload });
	};
}
export function clearValues() {
	return { type: CLEAR_VALUES };
}

export function getMei(id: string, callback?: Callback<IMei>) {
	return async (dispatch: any, getState: any) => {
		dispatch({ type: GET_MEI });

		try {
			const { login } = getState() as State;

			const response = await api.sendGet("/Mei/" + id, {
				Authorization: `Bearer ${login.token}`
			});

			const result = await response.json();

			if (result.isValid) {
				dispatch({
					type: GET_MEI_SUCCESS,
					payload: result.model
				});

				callback && callback(null, result.model);
			} else {
				const errors = getErrors(result.errors);

				dispatch({
					type: GET_MEI_FAILED,
					payload: errors
				});
				callback && callback(errors);
			}
		} catch (error) {
			callback && callback(error);

			return dispatch({
				type: GET_MEI_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}

export function updateMei(callback?: Callback<IMei>) {
	return async (dispatch: any, getState: any) => {
		dispatch({ type: EDIT_MEI });

		try {
			const state = getState();

			const { login, meiEdit } = state;

			const {
				item,
				cnpj,
				situation,
				logisticOperator,
				logisticOperatorStatus,
				parentOperator
			} = meiEdit;

			const errors: any = {};

			if (!cnpj) errors.cnpj = "CNPJ é obrigatório";
			else if (!CNPJValidation(cnpj)) errors.cnpj = "CNPJ inválido";

			dispatch(setValue({ errors }));

			if (Object.keys(errors).length)
				return dispatch({ type: SET_VALUE, payload: { loading: false } });

			const model = {
				...item,
				situation,
				cnpj: cnpj.match(/\d/g)?.join(""),
				logisticOperator: logisticOperator?._id || logisticOperator,
				logisticOperatorStatus,
				parentOperator: parentOperator?._id || parentOperator?.id || parentOperator || undefined
			};

			const response = await api.sendPut("/Mei/" + item._id, model, {
				Authorization: `Bearer ${login.token}`
			});

			if (response.ok) {
				dispatch({
					type: EDIT_MEI_SUCCESS
				});

				callback && callback();
			} else {
				const result = await response.json();

				const errors = getErrors(result.errors);

				dispatch({
					type: EDIT_MEI_FAILED,
					payload: errors
				});
				callback && callback(errors);
			}
		} catch (error) {
			return dispatch({
				type: EDIT_MEI_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}
